import { Scope } from 'constants/scope';
import { getConfig } from 'helpers/config';
import type { ProductData } from 'services/api/accounts/interfaces';
import { trackEvent } from 'services/event-tracking';

import type { LegacyMigrationEvent } from './constants';

const BILLING_SCOPES = [Scope.SubscriptionRW, Scope.SubscriptionLCRW, Scope.SubscriptionCBRW, Scope.SubscriptionHDRW];

export function hasLegacyMigrationBillingPermission(scopes: Scope[]): boolean {
  return scopes.some((scope) => BILLING_SCOPES.includes(scope));
}

export function hasLegacyMigrationProducts(products: ReadonlyArray<Pick<ProductData, 'product'>>): boolean {
  const installedProducts = new Set<ProductData['product']>(products.map(({ product }) => product));

  return installedProducts.has('LiveChat') && installedProducts.has('TextApp');
}

export function isLegacyMigrationSurfaceDismissed(
  permanentlyDismissed: boolean,
  dismissedUntil: number,
  now: number = Date.now(),
): boolean {
  return permanentlyDismissed || dismissedUntil > now;
}

export function getLegacyMigrationLandingUrl(): string {
  return `${getConfig().textAppUrl}/settings/billing/transition`;
}

export function getAiAgentActivationUrl(): string {
  return `${getConfig().textAppUrl}/team/ai-agents/`;
}

export function trackLegacyMigrationEvent(
  event: LegacyMigrationEvent,
  extraProperties: Record<string, string> = {},
): void {
  trackEvent(event, null, {
    // The historical Ampli event schema uses snake_case for this property.
    // eslint-disable-next-line @typescript-eslint/naming-convention
    migration_segment: 'forced',
    ...extraProperties,
  });
}
